export const useCanonicalUrlForSearchPages = () => {
  const cityPages = useCityPages();
  const route = useRoute();

  return computed(() => {
    const cityNameInPath = cityPages.names.find((cityName) => route.path.includes(cityName));
    if (cityNameInPath) {
      return `/${cityNameInPath}`;
    }

    const queryParams = <string[]>[];
    if (route.query?.housingType) {
      queryParams.push(`housingType=${route.query?.housingType}`);
    }
    if (route.query?.['locationIds[cities]']) {
      queryParams.push(`locationIds[cities]=${route.query?.['locationIds[cities]']}`);
    }
    if (queryParams.length) {
      return `${route.path}?${queryParams.join('&')}`;
    }

    return `${route.path}`;
  });
};
